module.exports = __webpack_public_path__ + "static/media/style-6-de.7bee409c.png";